// アンカーリンクスクロール
const smoothAnkerScroll = (hash) =>{
  const targetElement = document.querySelector(hash);
  const rect = targetElement.getBoundingClientRect().top;
  const offset = window.pageYOffset;
  const target = rect + offset;
  window.scrollTo({
    top: target,
    behavior: 'smooth',
  });
}

window.addEventListener("DOMContentLoaded",() => {
  // 初期表示時
  const firstViewHash = decodeURI(location.hash);
  if(firstViewHash){
    smoothAnkerScroll(firstViewHash);
  }

  // アンカーリンク押下時
  const smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');
  for (let i = 0; i < smoothScrollTrigger.length; i++){
    smoothScrollTrigger[i].addEventListener('click', (e) => {
      e.preventDefault();
      let href = smoothScrollTrigger[i].getAttribute('href');
      smoothAnkerScroll(href);
    });
  }

  // セレクト要素のアンカーリンクスクロール
  const selectScrollTrigger = document.querySelectorAll('.select__ankerlink'); 
  for (let i = 0; i < selectScrollTrigger.length; i++){
    selectScrollTrigger[i].addEventListener('change', (e) => {
      let href = selectScrollTrigger[i].value;
      smoothAnkerScroll(href);
    });  
  }
});